<template>
  <v-card color="grey lighten-3" class="pa-2 mb-3">
    <v-card-title>
      <h4 class="subheading my-0">Datos del tipo de contrato</h4>
    </v-card-title>
    <v-select
      v-model="formData.tipo_de_contrato"
      :disabled="disabled"
      @input="$emit('input', formData)"
      :label="$t('Tipo de contrato')"
      :items="tiposDeContrato"
      :rules="[rules.required]"
      required
      item-text="label"
      item-value="value"
      box
      :menu-props="{
        bottom: true,
        'offset-y': true,
      }"
    >
      <template slot="prepend" v-if="showInfoIcon">
        <v-btn @click="toggleInfo()" class="mt-0 pt-0" flat icon color="secondary">
          <v-icon small>mdi-information</v-icon>
        </v-btn>
      </template>
    </v-select>

    <template v-if="formData.tipo_de_contrato === 'indefinido_fijo_discontinuo'">
      <v-alert v-model="showInfo" color="blue-grey" dismissible type="info" class="mb-3">
        <p>
          Objeto: Contrato que puede concertarse para la realización de trabajos de naturaleza
          estacional o vinculados a actividades productivas de temporada, o para el desarrollo de
          aquellos que no tengan dicha naturaleza pero que, siendo de prestación intermitente,
          tengan periodos de ejecución ciertos, determinados o indeterminados.
        </p>
        <p>
          En la duración estimada indicar el número de meses del año en los que el trabajador va a
          estar activo en la empresa, sumando todos sus periodos de actividad.
        </p>
      </v-alert>
      <contrato-indefinido-fijo-discontinuo
        v-model="formData.indefinido_fijo_discontinuo"
        :disabled="disabled"
      ></contrato-indefinido-fijo-discontinuo>
    </template>
    <template v-if="formData.tipo_de_contrato === 'eventual_no_previsible'">
      <v-alert v-model="showInfo" color="blue-grey" dismissible type="info" class="mb-3">
        <p>
          Objeto: Contrato que puede concertarse

          <b>
            cuando exista un incremento ocasional e imprevisible de las circunstancias de la
            producción que,
          </b>
          aun tratándose de la actividad normal de la empresa, generen un desajuste temporal entre
          el empleo estable disponible
        </p>
        <p>
          Indemnización: Parte proporcional de la cantidad que resultaría de abonar 12 días de
          salario por año de servicio, o la establecida por convenio.
        </p>
        <p>
          Duración:
          <b>Máxima de 6 meses en un periodo de 12 meses,</b>
          aunque el convenio colectivo puede permitir que la duración del contrato eventual sea de
          un año como máximo en un periodo de dieciocho meses.
        </p>
      </v-alert>
      <contrato-eventual v-model="formData.eventual" :disabled="disabled"></contrato-eventual>
    </template>
    <template v-if="formData.tipo_de_contrato === 'eventual_previsible'">
      <v-alert v-model="showInfo" color="blue-grey" dismissible type="info" class="mb-3">
        <p>
          Objeto: Contrato que puede concertarse
          <b>
            para atender situaciones ocasionales, previsibles y que tengan una duración reducida y
            delimitada.
          </b>
          aun tratándose de la actividad normal de la empresa a diferencia del contrato para obra o
          servicio determinado.
        </p>
        <p>
          Indemnización: Parte proporcional de la cantidad que resultaría de abonar 12 días de
          salario por año de servicio, o la establecida por convenio.
        </p>
        <p>
          Duración: La empresa puede utilizar este contrato para el número de trabajadores que
          necesite, como máximo 90 días durante el año natural, no pudiendo ser utilizados de manera
          continuada.
        </p>
      </v-alert>
      <contrato-eventual v-model="formData.eventual" :disabled="disabled"></contrato-eventual>
    </template>
    <template v-if="formData.tipo_de_contrato === 'sustitucion'">
      <v-alert v-model="showInfo" color="blue-grey" dismissible type="info">
        <p>
          Contrato que puede concertarse para sustituir a trabajadores con derecho a reserva del
          puesto de trabajo en caso de: bajas médicas, maternidad, paternidad, reducciones de
          jornada o para cubrir un puesto de trabajo durante el proceso de selección.
        </p>
        <p>
          Este tipo de contrato NO se puede utilizar para cubrir vacaciones o permisos retribuidos
          de los trabajadores, en ese caso sería un contrato eventual por circunstancias de la
          producción no previsibles.
        </p>
      </v-alert>
      <contrato-sustitucion
        v-model="formData.sustitucion"
        :disabled="disabled"
      ></contrato-sustitucion>
    </template>
    <template v-if="formData.tipo_de_contrato === 'formacion'">
      <v-alert v-model="showInfo" color="blue-grey" dismissible type="info" class="mb-3">
        <p>
          Objeto: Contrato que puede concertarse para compatibilizar la actividad laboral retribuida
          con los correspondientes procesos formativos en el ámbito de la formación profesional, los
          estudios universitarios o del Catálogo de especialidades formativas del Sistema Nacional
          de Empleo.
        </p>
        <p>
          Duración: la prevista en el programa formativo con un mínimo de 3 meses y un máximo de 2
          años.
        </p>
        <p>
          Bonificación: 100% de las cuotas a la Seguridad Social tanto empresariales como del
          trabajador de la base de cotización por SMI. Si se transforma en indefinido, obtendrían
          una bonificación durante 3 años de 1500€/año y 1800€/año en el caso de ser mujer.
        </p>
        <p>
          Es un contrato que tiene varios requisitos y debe coordinarse con un centro o entidad
          formativa, por tanto, recomendamos solicitar información a su asesor laboral.
        </p>
      </v-alert>
    </template>
    <template v-if="formData.tipo_de_contrato === 'practicas'">
      <v-alert v-model="showInfo" color="blue-grey" dismissible type="info" class="mb-3">
        <p>
          Objeto: Contrato que puede concertarse para obtener la práctica profesional adecuada al
          nivel de estudios ya finalizado por el trabajador. Debe ser suscrito dentro de los 3 años
          siguientes a la terminación de los estudios.
        </p>
        <p>
          Duración: No podrá ser inferior a 6 meses ni exceder de un año.
        </p>
        <p>
          Bonificación: En caso de transformarlo en indefinido, obtendrían una bonificación durante
          3 años a razón de 500 €/año para hombres y 700€/año para mujeres.
        </p>
      </v-alert>
    </template>
    <template v-if="formData.tipo_de_contrato === 'practicas_curriculares'">
      <v-alert v-model="showInfo" color="blue-grey" dismissible type="info" class="mb-3">
        <p>
          Objeto: se formaliza para la realización de prácticas académicas externas por parte de
          estudiantes que están actualmente cursando estudios de ciclo formativo o universitarios
          con el objetivo de complementar los conocimientos que estén adquiriendo en su formación
          académica.
        </p>
        <p>
          Es necesario firmar un acuerdo con el centro de estudios, universidad o entidad formativa
          y debes adjuntarlo por si fuera necesario presentarlo a Seguridad Social.
        </p>
      </v-alert>
      <practicas-curriculares
        v-model="formData.practicas_curriculares"
        :disabled="disabled"
      ></practicas-curriculares>
    </template>
  </v-card>
</template>

<script>
import ContratoEventual from '../tipos-de-contratos/ContratoEventual.vue';
import ContratoSustitucion from '../tipos-de-contratos/ContratoSustitucion.vue';
import ContratoIndefinidoFijoDiscontinuo from '@/modules/laboral/components/forms/laboral-requests/partials/tipos-de-contratos/ContratoIndefinidoFijoDiscontinuo.vue';
import PracticasCurriculares from '@/modules/laboral/components/forms/laboral-requests/partials/tipos-de-contratos/PracticasCurriculares.vue';

export default {
  components: {
    ContratoIndefinidoFijoDiscontinuo,
    ContratoEventual,
    ContratoSustitucion,
    PracticasCurriculares,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default() {
        return {
          tipo_de_contrato: null,
          eventual: {},
          sustitucion: {},
          indefinido_fijo_discontinuo: {},
          practicas_curriculares: {},
        };
      },
    },
  },
  data() {
    return {
      showInfo: true,
      rules: {
        required: value => !!value || 'Este campo es obligatorio.',
        counter: value => value.length <= 20 || 'Max 20 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || 'Email inválido';
        },
      },
      tiposDeContrato: [
        { label: 'Contrato indefinido', value: 'indefinido' },
        // { label: 'Temporal por obra/servicio', value: 'obra_y_servicio' },
        { label: 'Indefinido fijo-discontínuo', value: 'indefinido_fijo_discontinuo' },
        // {
        //   label: 'Eventual por circunstancias de la producción',
        //   value: 'eventual',
        // },
        {
          label: 'Eventual por circunstancias de la producción no previsibles',
          value: 'eventual_no_previsible',
        },
        {
          label: 'Eventual por circunstancias de la producción previsibles',
          value: 'eventual_previsible',
        },
        { label: 'Contrato de interinidad/sustitución', value: 'sustitucion' },
        { label: 'Contrato de formación en alternancia', value: 'formacion' },
        { label: 'Contrato para la obtención de la práctica profesional', value: 'practicas' },
        { label: 'Prácticas curriculares/extracurriculares', value: 'practicas_curriculares' },
        { label: 'Otros (formación y aprendizaje/prácticas)', value: 'otros', disabled: true },
      ],
    };
  },
  computed: {
    showInfoIcon() {
      return (
        this.formData.tipo_de_contrato &&
        (this.formData.tipo_de_contrato === 'obra_y_servicio' ||
          this.formData.tipo_de_contrato === 'eventual_no_previsible' ||
          this.formData.tipo_de_contrato === 'eventual_previsible')
      );
    },
    formData: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  mounted() {},
  methods: {
    toggleInfo() {
      this.showInfo = !this.showInfo;
    },
  },
  watch: {},
};
</script>

<style lang="scss"></style>
